/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { IdsDto } from '../model/idsDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class EMEService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param id
   */
  public async emeControllerGetEligibilityById(id: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling emeControllerGetEligibilityById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/eme/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param idsDto
   */
  public async emeControllerGetEligibilityByIds(idsDto: IdsDto, ): Promise<any> {
    if (idsDto === null || idsDto === undefined) {
      throw new Error('Required parameter idsDto was null or undefined when calling emeControllerGetEligibilityByIds.');
    }

    const localVarHeaders = this.defaultHeaders;

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/eme`,
        data: idsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
